<template lang="pug">
  .carouselwrapper
    carousel.carous(:per-page-custom="[[320, 1], [990, 3], [1199, 4]]", :per-page="4", navigationEnabled=true :spacePadding="8")
      slide.cli(v-for="(store, index) in items" :key="index")
        Store(:store="store")

</template>
<script>
import Store from '@/components/mercadolibre/Store'

export default {
  props: {
    items: Array
  },
  components: {
    Store
  },
}
</script>
<style lang="scss" scoped>
  .carouselwrapper{
    max-width: 1100px;
    margin: 2rem auto;
    width: 100vw;
    background-color: #eaeaea;
    padding: 1rem;
  }
  .cli{
    padding: 0.2rem 0;
  }
</style>


